"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AdminDashboard_1 = require("../../../components/Pages/AdminPages/AdminDashboard/AdminDashboard");
var AdminDash = function () {
    return React.createElement(AdminDashboard_1.default, null);
};
exports.default = AdminDash;
